import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ButtonModule } from 'primeng/button';

import { DashboardServiceService } from '@admin/shared/services/dashboard-service.service';

import { BillingService } from '@core/services/billing.service';
import { BillingPlan } from '@shared/models/billing-plan.model';
import { shouldShowUpgradeNav, sortPlans } from '@shared/utils/plan.utils';

@Component({
  selector: 'app-mobile-sidebar',
  imports: [ButtonModule, RouterLink],
  templateUrl: './mobile-sidebar.component.html',
  styleUrl: './mobile-sidebar.component.scss',
})
export class MobileSidebarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  selectedWorkspace: any;
  billingPlans: BillingPlan[] = [];

  constructor(
    private dashboardService: DashboardServiceService,
    private billingService: BillingService
  ) {}

  ngOnInit() {
    this.billingService
      .getBillingPlans()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.billingPlans = sortPlans(response.plans);
      });

    this.dashboardService.getWorkspace().subscribe((workspace) => {
      this.selectedWorkspace = workspace;
    });
  }

  showUpgradeNav(): boolean {
    return shouldShowUpgradeNav(this.selectedWorkspace, this.billingPlans);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
